import { module } from 'modujs';
import { CUSTOM_EVENT } from '../config';

export default class extends module {
    constructor(m) {
        super(m);

        this.onVisitEnd = this.onVisitEnd.bind(this);

        this.contentAttribute = '[data-skip-link-content]';

        this.events = {
            click: {
                button: 'onClick'
            }
        }
    }

    //////////////
    // Lifecyle
    //////////////

    init() {
        this.bindEvents()
        this.onVisitEnd()
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    //////////////
    // Events
    //////////////

    bindEvents() {
        window.addEventListener(CUSTOM_EVENT.VISIT_END, this.onVisitEnd)
    }

    unbindEvents() {
        window.removeEventListener(CUSTOM_EVENT.VISIT_END, this.onVisitEnd)
    }

    onVisitEnd() {
        if(document.querySelector(this.contentAttribute)) {
            document.querySelector(this.contentAttribute).setAttribute('tabindex', '-1');
        } else {
            document.getElementById('main').setAttribute('tabindex', '-1');
        }
    }

    onClick(event) {
        event.preventDefault();

        let targetContent = document.querySelector(this.contentAttribute) || document.getElementById('main') || null;

        if (targetContent) {
            this.call('scrollTo', {
                target: targetContent,
                options: {
                    duration: 1,
                    offset: -150,
                },
            }, 'Scroll');

            targetContent.focus();
        }
    }
}
